import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { CloseDark } from '../../../icons/icons';
import './WebViewModal.scss';
import { getFieldIdByName, getField } from '../../selectors';
import { TemplateAction } from '../../../types/template-types';
import { validateUrl } from '../../../helpers/helpers';
import { showBanner } from '../../../helpers/MessageUtility';
import { ValueChangedFunc } from '../../formeditor-types';

export interface WebViewProps {
  action?: TemplateAction;
  onClose?: (hasError?: boolean) => void;
  calculationRunner?: TypeMePlease;
  formValues?: TypeMePlease;
  template?: TypeMePlease;
  valueChanged?: ValueChangedFunc;
}

export default function WebView(props: WebViewProps) {
  const [url, setUrl] = useState();
  const { name } = props.action;
  const [hasError, setHasError] = useState(false);

  const webViewReturn = (data) => {
    if (props.action.mapping) {
      for (const mapping of props.action.mapping) {
        if (data[mapping.webViewProperty]) {
          const fieldId = getFieldIdByName(props.template, mapping.templateProperty);
          if (fieldId) {
            props.valueChanged({ value: data[mapping.webViewProperty] }, getField(props.template, fieldId));
          }
        }
      }
    }

    props.onClose(hasError);
  };

  const onMessage = (event) => {
    if (event.origin !== 'https://postback.goformz.com') return;

    if (event.data && event.data.type === 'webViewReturn') {
      webViewReturn(event.data.data);
    }
  };

  useEffect(() => {
    if (props.calculationRunner && props.action?.url && props.formValues) {
      props.calculationRunner.executeFormula(props.action.url, props.formValues).then((result) => {
        setUrl(result);
        setHasError(!validateUrl(result));
      });
    }
  }, [props.calculationRunner, props.action?.url, props.formValues]);

  useEffect(() => {
    if (hasError) {
      showBanner(`Invalid URL for ${name}. Please try again.`, 'error');
      props.onClose(hasError);
      return;
    }

    window.addEventListener('message', onMessage, false);
    return () => {
      window.removeEventListener('message', onMessage, false);
    };
  }, [hasError]);

  return (
    <Modal open={!hasError} dimmer="inverted" onClose={() => props.onClose(hasError)} className="custom-action-webview">
      <Modal.Header>
        {props.action.name}
        <button className="close-button plain-button" tabIndex={-1} onClick={() => props.onClose(hasError)}>
          <CloseDark />
        </button>
      </Modal.Header>
      <Modal.Content>{url ? <iframe src={url} /> : null}</Modal.Content>
    </Modal>
  );
}
